import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const slice = createSlice({
  name:"$collapseOptionalChoiceSetsByDefault",
  initialState: false,
  reducers: {
    setCollapseOptionalChoiceSetsByDefault(_, action: PayloadAction<boolean>) {
      return action.payload;
    }
  }
});

export const {setCollapseOptionalChoiceSetsByDefault} = slice.actions;

export default slice.reducer;
